import { render, staticRenderFns } from "./ServiceModel.vue?vue&type=template&id=d89057a6&scoped=true&"
import script from "./ServiceModel.vue?vue&type=script&lang=js&"
export * from "./ServiceModel.vue?vue&type=script&lang=js&"
import style0 from "./ServiceModel.vue?vue&type=style&index=0&id=d89057a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89057a6",
  null
  
)

export default component.exports